import gql from "graphql-tag";
import { clientHelper } from "utils/graphQL";

export const UPDATE_APP_LANGUAGE = gql`
  mutation updateAppLanguage(
    $cID: ID!,
    $payload: CandidateEditInput!
  ){
    mutate(type: CandidateMutation, id: $cID) {
      id
      ... on CandidateMutation {
        edit(payload: $payload){
          app_language
        }
      }
    }
  }
`;

export const updateAppLanguage = async (candId, payload, client) => {
  const { data, error } = await clientHelper("mutate")(client)({
    mutation: UPDATE_APP_LANGUAGE,
    variables: {
      cID: candId,
      payload
    }
  });

  return {
    data, 
    error
  }
}